import React from "react";
import { cn } from "~/lib/cn";

interface ColumnsProps {
  count?: "1" | "2" | "3" | "4";
  children?: React.ReactNode;
}

const COUNT_CLASSES = {
  "1": "md:grid-cols-1",
  "2": "md:grid-cols-2",
  "3": "md:grid-cols-3",
  "4": "md:grid-cols-4",
};

export const Columns = ({ count = "1", children }: ColumnsProps) => (
  <div className={cn("grid items-stretch gap-4", COUNT_CLASSES[count])}>
    {children}
  </div>
);
